import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { l } from '../lib/imports'
import { rando } from '../lib/rando-sidecar'
import { createId } from '../main/common'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { deathPunchSounds } from './deathPunchSounds-sidecar'
import { log } from './log-sidecar'
import { ui } from './ui-sidecar'

let introClick = false
export type IEnemyType = 'snake' | 'shriek' | 'foots'
interface IEnemy extends IEntity {
  direction: boolean
  distance: number
  sfxTimer: number
  isDead: boolean
  isKilled: boolean
  enemyType: IEnemyType
  minPoints: number
  soundId: number
}

interface IGameData {
  hitpoints: number
  speed: number
  resetTimer: number
  points: number
  pointsTimer: number
  swingTimer: number
  restartTimer: number
  lastAction: string

  enemy1: IEnemy
  enemy2: IEnemy
  enemy3: IEnemy

  introSoundId: number
  gameStarted: boolean
}

let _data: IGameData | null
const getData = (): IGameData => {
  if (!_data) {
    reset()
  }
  return _data as IGameData
}

export const getIntroClick = () => {
  return introClick
}

const reset = () => {
  l.forEach(objs, (c) => {
    c.isDead = true
  })

  if (_data) {
    deathPunchSounds.stopSound(_data.introSoundId)
  }
  _data = {
    hitpoints: 3,
    speed: 1,
    resetTimer: 0,
    points: 0,
    pointsTimer: 0,
    swingTimer: 1,
    restartTimer: 3,
    lastAction: '',
    enemy1: createEnemy(1, 0, 'snake'),
    enemy2: createEnemy(2, 4, 'foots'),
    enemy3: createEnemy(3, 8, 'shriek'),

    gameStarted: false,
    introSoundId: 0,
  }

  _data.introSoundId = deathPunchSounds.playIntro()

  // createEnemy(1)
}

const objs: IEnemy[] = []
const createEnemy = (distance: number, minPoints: number, type: IEnemyType) => {
  // let types: IEnemyType[] = [
  //   'snake',
  //   'snake',
  //   'snake',
  //   'foots',
  //   'foots',
  //   'shriek',
  // ]

  let obj: IEnemy = {
    id: createId(),
    isDead: false,
    isKilled: false,
    eType: 'death-punch-enemy',
    direction: rando.b(),
    distance,
    sfxTimer: 0,
    minPoints,
    enemyType: type, //rando.sample(types),
    soundId: 0,
  }
  objs.push(obj)
  return obj
}

export const create = () => {
  log.x('create')

  layers.create()

  const soundsJson = common.getPhaserScene().cache.json.get('audioSprite1')
  deathPunchSounds.load(soundsJson, 'assets/music')

  document.addEventListener(
    'mousedown',
    (event) => {
      if (!introClick) {
        introClick = true
        return
      }

      if (!getData().gameStarted) {
        getData().gameStarted = true
        deathPunchSounds.stopSound(getData().introSoundId)
        deathPunchSounds.playBegin()
        return
      }

      if (event.button === 0) {
        // left

        attack(false)
      }
      if (event.button === 2) {
        // right

        attack(true)
      }
      if (event.button === 1) {
        // middle

        reset()
      }
    },
    false,
  )

  // soundsGeneric.play

  reset()
}

export const attack = (dir: boolean) => {
  log.x('attack')

  let missTime = 0.33
  if (getData().swingTimer < missTime) {
    deathPunchSounds.playError(dir ? 1 : -1)
    return
  }

  let found: IEnemy | null = null as IEnemy | null
  l.forEach(objs, (c) => {
    if (c.direction === dir) {
      if (c.distance < 0.5) {
        found = c
        return false
      }
    }
  })
  if (found) {
    deathPunchSounds.playHit(dir ? 1 : -1)
    found.isKilled = true
    getData().points++
    getData().lastAction = 'Hit!!'
    getData().swingTimer = missTime

    deathPunchSounds.stopSound(found.soundId)

    spawnNewEnemy(found)
  } else {
    deathPunchSounds.playMiss(dir ? 1 : -1)
    getData().lastAction = '-miss-'
    if (getData().points > 2) {
      getData().points -= 0.25
    }
    getData().swingTimer = 0
    if (getData().points < 0) {
      getData().points = 0
    }
  }
}

export const spawnNewEnemy = (obj: IEnemy) => {
  setTimeout(() => {
    obj.isKilled = false
    obj.distance = rando.f(1.1, 2)
    obj.direction = rando.b()
    obj.sfxTimer = 0
  }, rando.i(250, 500))

  // )
  // createEnemy(rando.f(1.1, 2))
}

export const update = () => {
  let d = getData()
  let dt = common.getUpdateDelta()

  let speed = d.speed

  if (!d.gameStarted) {
    ui.updateScore(d.points, speed, d.hitpoints, d.lastAction)
    return
  }

  d.restartTimer -= dt
  if (d.restartTimer > 0) {
    speed = d.restartTimer
    ui.updateScore(d.points, speed, d.hitpoints, d.lastAction)
    return
  }
  ui.updateScore(d.points, speed, d.hitpoints, d.lastAction)

  d.swingTimer += dt
  if (d.hitpoints === 0) {
    if (d.resetTimer > 5.5 && d.points > 0) {
      d.pointsTimer += dt
      if (d.pointsTimer > 0.8) {
        d.pointsTimer = 0
        if (d.points > 5) {
          deathPunchSounds.playFivePoint()
          d.points -= 5
        } else {
          deathPunchSounds.playPoint()
          d.points--
        }
      }
    } else {
      d.resetTimer += dt
      if (d.resetTimer > 8) {
        reset()
      }
    }
    return
  }

  d.speed += 0.05 * dt

  l.forEach(objs, (c) => {
    if (c.isDead || c.isKilled) {
      return
    }

    if (d.points < c.minPoints && c.minPoints > 0 && c.distance > 1) {
      return
    }

    c.distance -= (dt * d.speed) / 5
    c.sfxTimer -= dt * d.speed

    if (c.distance <= 1) {
      // Close enough to hear

      if (c.distance <= 0) {
        c.distance = 0
        c.isKilled = true

        let channel = 1 //c.distance
        if (!c.direction) {
          channel = -channel
        }

        deathPunchSounds.playHurt(channel)
        deathPunchSounds.stopSound(c.soundId)

        d.lastAction = 'Hurt!'

        d.hitpoints--
        if (d.hitpoints <= 0) {
          deathPunchSounds.playGameover()

          setTimeout(() => {
            deathPunchSounds.playDied()
          }, 2500)

          d.lastAction = 'Died'
        } else {
          spawnNewEnemy(c)
        }
      }

      if (c.sfxTimer <= 0 && !c.isKilled) {
        c.sfxTimer = 1
        let channel = 1 //c.distance
        if (!c.direction) {
          channel = -channel
        }
        let volume = (1 - c.distance) * 0.9 + 0.1
        c.soundId = deathPunchSounds.playFootsteps(channel, volume, c.enemyType)
      }
    }
  })

  entitiesUtils.removeDead(objs, (c) => {})
}
